// extracted by mini-css-extract-plugin
export default {"wrapTable":"AgreementPriceListUerModal_wrapTable__wHRMy"};